import { Flex, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import DefaultButton from "components/Button/PrimaryButton";
import { TipoCadastroEmpresa } from "resources/types/empresa";
import DadosDeEndereco from "ui/components/FormEndereco";
import useGetFornecedorEndereco from "core/features/fornecedores/hooks/useGetFornecedorEndereco";
import usePutFornecedorEndereco from "core/features/fornecedores/hooks/usePutFornecedorEndereco";
import { showSuccess, showErrorAxios } from "infra/helpers/alerta";
import { useLoading } from "ui/components/GlobalLoading";
import { FornecedorEndereco } from "core/features/fornecedores/typings/index";
import OutlineButton from "ui/components/Button/OutlineButton";
import history from "infra/helpers/history";

interface DadosEnderecoProps {
  isEdit?: boolean;
  id: string;
}

interface FormEndereco {
  endereco: FornecedorEndereco;
}

function DadosEndereco({ isEdit, id }: DadosEnderecoProps) {
  const { data, isLoading, isFetching } = useGetFornecedorEndereco(id);
  const { mutate: handleSave, isLoading: isSaveLoading } =
    usePutFornecedorEndereco(id);
  const { control, watch, handleSubmit, setValue, reset } =
    useForm<FormEndereco>({});

  const onSubmit = (data: FormEndereco) => {
    handleSave(data.endereco, {
      onSuccess: () => {
        showSuccess();
      },
      onError: (err) => {
        showErrorAxios(err);
      },
    });
  };

  useEffect(() => {
    if (data) {
      reset({ endereco: data });
    }
  }, [data, reset]);

  useLoading(isLoading || isFetching);

  return (
    <>
      <form onSubmit={(ev) => handleSubmit(onSubmit)(ev)}>
        <Text mb="16px" fontSize="18px">
          Endereço
        </Text>
        <DadosDeEndereco
          control={control}
          setField={setValue}
          watch={watch}
          required={false}
          shouldUnregister={!TipoCadastroEmpresa.Fornecedor && !isEdit}
        />

        <Flex mt="16px" gap={4} justifyContent={"flex-end"}>
          <OutlineButton
            onClick={() => history.push(`/cadastros/fornecedores`)}
          >
            Voltar
          </OutlineButton>
          <DefaultButton
            type="submit"
            isLoading={isSaveLoading}
            disabled={isSaveLoading}
          >
            Salvar
          </DefaultButton>
        </Flex>
      </form>
    </>
  );
}

export default DadosEndereco;
